<script setup>
defineProps({
    label: String,
    modelValue: Boolean,
});

defineEmits(["update:modelValue"]);
</script>

<template>
    <button
        class="flex items-center gap-3"
        @click="$emit('update:modelValue', !modelValue)"
    >
        <span
            class="body-xs flex-1 text-left leading-[0.8] font-bold uppercase"
        >
            {{ label }}
        </span>
        <div class="flex items-center gap-1">
            <span
                class="body-xs leading-[0.8] font-medium faded-text uppercase"
            >
                off
            </span>
            <div class="bg-marine-600 relative flex w-10 p-0.5">
                <div
                    :class="[
                        'size-4 transition-all duration-200',
                        modelValue
                            ? 'translate-x-[22px] bg-yellow-400'
                            : 'translate-x-0 bg-white/50',
                    ]"
                />
            </div>
            <span
                :class="[
                    'body-xs leading-[0.8] font-medium uppercase transition-colors duration-200',
                    modelValue ? 'text-yellow-400' : 'faded-text',
                ]"
            >
                on
            </span>
        </div>
    </button>
</template>
